import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { InitialApp } from "./initializeApp";

export const NotWorking = () => {
  return (
    <div dir="rtl" style={{ height: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
      <h4>سامانه درحال حاضر در دسترس نمی باشد لطفا بعدا مراجعه فرمایید.</h4>
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
const item = await InitialApp();
if (item) {
  root.render(
    // <React.StrictMode>

    <App />,

    // </React.StrictMode>,
  );
} else {
  root.render(<NotWorking />);
}
